<template>
  <div v-loading="loading">
    <avue-form :option="optionForm" ref="form" v-model="formData">
      <template slot="contractMoney">
        <custom-input v-model="formData.contractMoney" :precision="3" />
      </template>
    </avue-form>
    <FormTable ref="formTable" :formData="formData" :optionConfig="optionConfig" />
    <span slot="dialog_footer" class="dialog-footer" v-if="!isDetails()">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
  </div>
</template>

<script>
import { add, update, getDetail, uploadEndpoint } from "../api";
import { disposeDetail, showItem, rulesInput } from '@/basic-common/util/common.js';
import { getTodayDateStr } from '@/util/date';
// import _ from 'lodash';
export default {
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      title: '',
      show: false,
      loading: false,
      formData: {
        list: []
      },
      // 表单配置
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        detail: this.isDetails(), //启用form详情央视
        column: [
          {
            label: '合同编号',
            prop: 'contractNo',
            maxlength: 30,
            display: showItem(
              { add: false, edit: false, view: true },
              this.transmitData.type
            ),
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: '合同名称',
            prop: 'contractName',
            maxlength: 30,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: '物资名称',
            prop: 'varNames',
            readonly: true,
            display: showItem(
              { add: false, edit: false, view: true },
              this.transmitData.type
            ),
          },
          {
            label: '货主',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
            rules: rulesInput(2),
          },
          //{
          //  label: '业务类型',
          //  prop: 'businessType',
          //  overHidden: true, // 表格超出隐藏
          //  type: 'select',
          //  dataType: 'string',
          //  dicData: this.$store.getters.commonDict['businessType'],
          //  rules: rulesInput(2),
          //  props: {
          //    label: 'dictValue',
          //    value: 'dictKey',
          // },
          //},
          {
            label: '合同约定量(吨)',
            prop: 'contractWeight',
            precision: 2,
            min: 0.01,
            max: 99999,
            maxlength: 12,
            display: showItem(
              { add: false, edit: false, view: true },
              this.transmitData.type
            ),
          },
          {
            label: '合同金额(元)',
            prop: 'contractMoney',
          },
          {
            label: '合同开始日期',
            prop: 'contractStartTime',
            overHidden: true,
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入开始时间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '合同结束日期',
            prop: 'contractEndTime',
            overHidden: true,
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入结束时间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '签订日期',
            prop: 'contractSignDate',
            overHidden: true,
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: "合同附件",
            prop: "annexPath",
            type: "upload",
            multiple: true,
            drag: true,
            propsHttp: { res: "data", url: "link" },
            dataType: "string",
            slot: true,
            span: 24,
            hide: true,
            tip: "请上传标准格式文件, 最多可上传5个",
            limit: 5,
            action: '/api/blade-resource/oss/endpoint/put-file-attach',
          },
        ]
      },
      // 表格配置
      optionConfig: {
        columnType: this.transmitData.type,
        column: [
          {
            label: '物资名称',
            prop: 'cargoName',
            required: true,
            type: 'autocomplete-reset',
            typeUse: 'cargoName',
            unique: true,
          },
          {
            label: '合同约定量(吨)',
            prop: 'contractWeight',
            type: 'custom-input',
            precision: 2,
            required: true,
            maxlength: 8,
          },
          {
            label: '合同入库量(吨)',
            prop: 'inWeight',
            type: 'custom-input',
            add: false,
            edit: false,
          }, {
            label: '合同出库量(吨)',
            prop: 'outWeight',
            type: 'custom-input',
            precision: 2,
            add: false,
            edit: false,
          },
          // {
          //   label: '合同剩余量(吨)',
          //   prop: 'remainWeight',
          //   add: false,
          //   edit: false,
          // },
          // {
          //   label: '进度偏差率',
          //   prop: 'deviationRate',
          //   add: false,
          //   edit: false,
          // },
        ]
      },
    }
  },
  created () {
    const { type, id } = this.transmitData
    if (type != 'add') {
      this.getDetail(id)
    } else {
      this.setDefaultDateFields()
    }
  },
  methods: {
    // 新增时给时间相关字段默认当天
    setDefaultDateFields () {
      const today = getTodayDateStr()
      ;['contractStartTime', 'contractEndTime', 'contractSignDate'].forEach(field => {
        if (!this.formData[field]) {
          this.$set(this.formData, field, today)
        }
      })
    },
    // 回显信息初始化
    getDetail (id) {
      this.loading = true
      getDetail(id).then(res => {
        const data = res && res.data && res.data.data ? res.data.data : {}
        this.formData = {
          ...data,
          list: Array.isArray(data.list) ? data.list : [],
        }
        // 特殊处理详情 主表和子表， 禁用问题，悬浮提示问题。
        this.$nextTick(() => {
          if (!this.isDetails()) return
          const formRef = this.$refs.form
          const tableRef = this.$refs.formTable
          formRef && disposeDetail(formRef)
          tableRef && disposeDetail(tableRef, 'table-details')
        })
      }).finally(() => {
        this.loading = false
      })

    },
    //提交
    async submitForm () {
      const list = this.formData.list
      if (!list.length) {
        return this.$message.error('请录入表格数据并验证必填项')
      }
      const subFormValidate = await this.$refs.formTable.getValidate()
      this.$refs.form.validate((valid, done) => {
        if (valid && subFormValidate) {
          const { type } = this.transmitData
          const submtFn = {
            add,
            edit: update
          }
          submtFn[type](this.formData).then(res => {
            this.$emit('handleClose', 'refresh')
          }).finally(() => {
            done()
          })
        } else {
          done()
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
      // }, 1500)
    },
    // 是否是详情
    isDetails () {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .avue-image-preview__file {
  z-index: 200000 !important;
}
</style>
